/**
 * Generative Plugin
 */

import type { Plugin } from '@plugins/Plugin';
import type { RepeaterDomainAdapter } from '@nodes/Dependencies';
import { createPolylineAdapter } from './polylineAdapter';
import { Domain } from '@nodes/Endpoint';
import { snakePatternNodeDef } from './SnakePatternNode/SnakePatternNode';
import { lsystemNodeDef } from './LSystemNode/LSystemNode';
import { turtleNodeDef } from './TurtleNode/TurtleNode';
import { repeaterNodeDef } from './RepeaterNode/RepeaterNode';
import { scatterNodeDef } from './ScatterNode/ScatterNode';
import { wangTilerNodeDef } from './WangTilerNode/WangTilerNode';
import { heightSamplerNodeDef } from './HeightSamplerNode/HeightSamplerNode';
import { subdivisionLayoutNodeDef } from './SubdivisionLayoutNode/SubdivisionLayoutNode';
import { snakeLayoutNodeDef } from './SnakeLayoutNode/SnakeLayoutNode';
import { rectangle2DNodeDef } from './Rectangle2DNode/Rectangle2DNode';
import { roofNodeDef } from '../threejs/nodes/RoofNode';
import { pathNodeDef } from '../threejs/nodes/PathNode';
import { getThree } from '../threejs/threejsPlugin';

const allNodes = [
  snakePatternNodeDef,
  lsystemNodeDef,
  turtleNodeDef,
  repeaterNodeDef,
  scatterNodeDef,
  wangTilerNodeDef,
  heightSamplerNodeDef,
  subdivisionLayoutNodeDef,
  snakeLayoutNodeDef,
  rectangle2DNodeDef,
  roofNodeDef,
  pathNodeDef,
];

export const generativePlugin: Plugin = {
  id: 'generative',
  name: 'Generative',
  namespace: 'gen',
  domain: Domain.Data,
  nodes: allNodes,
  createNode(type: string, id: string, deps: any) {
    const nodeDef = this.nodes!.find(n => n.type === type);
    if (!nodeDef) {
      throw new Error(`Unknown generative node type: ${type}`);
    }
    return new nodeDef.ctor(id, { ...deps, three: getThree() });
  },

  getRepeaterAdapters(): RepeaterDomainAdapter[] {
    return [createPolylineAdapter()];
  },

  async registerUI({ registerViz }) {
    const { GridVisualization } = await import('../data/nodes/GridNode/GridVisualization');
    const { CanvasVisualization } = await import('../video/ui/CanvasVisualization');
    registerViz('SnakePattern', GridVisualization);
    registerViz('Turtle', CanvasVisualization);
  }
};
